module.exports = __webpack_public_path__ + "static/media/mc.351af403.svg";